/**
 * Utility to get the API base URL
 * Auto-detects network IP when accessed from another device
 * In production, uses the same domain as the frontend
 */
export const getApiUrl = () => {
  // Use environment variable if set (for production builds)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Get current hostname and protocol
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // In production (not localhost), API is on same domain
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    // Check if we're in production (HTTPS or production domain)
    if (protocol === 'https:' || hostname.includes('.')) {
      // API is on same domain, possibly under /api path
      return `${protocol}//${hostname}/api`;
    }
    // Development on network
    return `${protocol}//${hostname}:5000/api`;
  }
  
  // Local development
  return 'http://localhost:5000/api';
};

export const getBaseUrl = () => {
  return getApiUrl().replace('/api', '');
};


